// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderBrown_loaderSection__USIoI","loaderSecitionh1":"loaderBrown_loaderSecitionh1__Jynei","lds_ring":"loaderBrown_lds_ring__aJIrF"};